import React from 'react';
import ProfileLayout from '../components/ProfileLayout';
import { ProfileContent } from './dashboard/Profile';

/**
 * Standalone Profile page (outside dashboard).
 * Used for all authenticated users; admins/organizers also have access via dashboard.
 */
const ProfilePage = () => (
  <ProfileLayout>
    <ProfileContent />
  </ProfileLayout>
);

export default ProfilePage;
